import { ColorProp } from "styles/themes";

import { SpendBuyerType } from "lib/types/graphQLEnums";
import { Dataset } from "./SpendChart";

/**
 * One fixed colour per top-level buyer type, so a type keeps its colour whatever its
 * rank under the current filters. The six types take the palette's best-separated
 * slots; the grey slot is kept for "No buyer type", so no real type is ever drawn in
 * the neutral colour.
 */
export const BUYER_TYPE_COLOURS: Record<SpendBuyerType, ColorProp> = {
  [SpendBuyerType.Central]: "sysChart1",
  [SpendBuyerType.Local]: "sysChart2",
  [SpendBuyerType.Healthcare]: "sysChart3",
  [SpendBuyerType.BlueLight]: "sysChart5",
  [SpendBuyerType.Education]: "sysChart6",
  [SpendBuyerType.Other]: "sysChart8",
  [SpendBuyerType.None]: "sysChart4",
};

const BUYER_TYPES = new Set<string>(Object.values(SpendBuyerType));

function isBuyerType(id: string): id is SpendBuyerType {
  return BUYER_TYPES.has(id);
}

/**
 * Pins each buyer type series to its colour, and "No buyer type" to the end of the
 * legend. The datasets are keyed by buyer type (see `buyerTypePointsAsGrouped`).
 */
export function withBuyerTypeColours(datasets: Dataset[]): Dataset[] {
  return datasets.map((dataset) => ({
    ...dataset,
    color: isBuyerType(dataset.id) ? BUYER_TYPE_COLOURS[dataset.id] : undefined,
    sortLast: dataset.id === SpendBuyerType.None,
  }));
}
